export const enums = {
  AccountTypeFilter: {
    AAD: "aad",
    MSA: "msa",
    NoFilter: "noFilter",
  },

  ApplicationMode: { Client: "client", WebEditor: "webEditor", WebViewer: "webViewer" },

  AsyncResultStatus: { Failed: "failed", Succeeded: "succeeded" },

  CoercionType: { Html: "html", Text: "text" }, // Outlook поддерживает только html и text

  DocumentMode: { ReadOnly: "readOnly", ReadWrite: "readWrite" },

  EventType: {
    AppCommandInvoked: "appCommandInvoked",
    AppointmentTimeChanged: "olkAppointmentTimeChanged",
    AttachmentsChanged: "olkAttachmentsChanged",
    DialogEventReceived: "dialogEventReceived",
    DialogMessageReceived: "dialogMessageReceived",
    DialogParentEventReceived: "dialogParentEventReceived",
    DialogParentMessageReceived: "dialogParentMessageReceived",
    EnhancedLocationsChanged: "olkEnhancedLocationsChanged",
    InfobarClicked: "olkInfobarClicked",
    ItemChanged: "olkItemSelectedChanged",
    OfficeThemeChanged: "officeThemeChanged",
    RecipientsChanged: "olkRecipientsChanged",
    RecurrenceChanged: "olkRecurrenceChanged",
    RichApiMessage: "richApiMessage",
    SelectedItemsChanged: "olkSelectedItemsChanged",
    SensitivityLabelChanged: "olkSensitivityLabelChanged",
  },

  FilterType: { All: "all" },

  InitializationReason: {
    ControlActivation: "controlActivation",
    DocumentOpened: "documentOpened",
    Inserted: "inserted",
  },

  HostType: {
    Access: "Access",
    Excel: "Excel",
    OneNote: "OneNote",
    Outlook: "Outlook",
    PowerPoint: "PowerPoint",
    Project: "Project",
    Visio: "Visio",
    Word: "Word",
  },

  PlatformType: {
    Android: "Android",
    Mac: "Mac",
    OfficeOnline: "OfficeOnline",
    PC: "PC",
    Universal: "Universal",
    iOS: "iOS",
  },

  ValueFormat: { Formatted: "formatted", Unformatted: "unformatted" },

  MailboxEnums: {
    ActionType: { ExecuteFunction: "executeFunction", ShowTaskPane: "showTaskPane" },

    AppointmentSensitivityType: {
      Confidential: "confidential",
      Normal: "normal",
      Personal: "personal",
      Private: "private",
    },

    AttachmentContentFormat: { Base64: "base64", Eml: "eml", ICalendar: "iCalendar", Url: "url" },

    AttachmentStatus: { Added: "added", Removed: "removed" },

    AttachmentType: { Cloud: "cloud", File: "file", Item: "item" },

    BodyType: { Html: "html", Text: "text" },

    CategoryColor: {
      None: "None",
      Preset0: "Preset0",
      Preset1: "Preset1",
      Preset2: "Preset2",
      Preset3: "Preset3",
      Preset4: "Preset4",
      Preset5: "Preset5",
      Preset6: "Preset6",
      Preset7: "Preset7",
      Preset8: "Preset8",
      Preset9: "Preset9",
      Preset10: "Preset10",
      Preset11: "Preset11",
      Preset12: "Preset12",
      Preset13: "Preset13",
      Preset14: "Preset14",
      Preset15: "Preset15",
      Preset16: "Preset16",
      Preset17: "Preset17",
      Preset18: "Preset18",
      Preset19: "Preset19",
      Preset20: "Preset20",
      Preset21: "Preset21",
      Preset22: "Preset22",
      Preset23: "Preset23",
      Preset24: "Preset24",
    },

    ComposeType: { Forward: "forward", NewMail: "newMail", Reply: "reply" },

    Days: {
      Day: "day",
      Fri: "fri",
      Mon: "mon",
      Sat: "sat",
      Sun: "sun",
      Thu: "thu",
      Tue: "tue",
      Wed: "wed",
      Weekday: "weekday",
      WeekendDay: "weekendDay",
    },

    DelegatePermissions: { DeleteAll: 8, DeleteOwn: 4, EditAll: 32, EditOwn: 16, Read: 1, Write: 2 },

    EntityType: {
      Address: "address",
      Contact: "contact",
      EmailAddress: "emailAddress",
      FlightReservations: "flightReservations",
      MeetingSuggestion: "meetingSuggestion",
      ParcelDeliveries: "parcelDeliveries",
      PhoneNumber: "phoneNumber",
      TaskSuggestion: "taskSuggestion",
      Url: "url",
    },

    Folder: { DeletedItems: "deletedItems", Inbox: "inbox", Junk: "junk" },

    ItemNotificationMessageType: {
      ErrorMessage: "errorMessage",
      InformationalMessage: "informationalMessage",
      InsightMessage: "insightMessage",
      ProgressIndicator: "progressIndicator",
    },

    ItemType: { Appointment: "appointment", Message: "message" },

    LocationType: { Custom: "custom", Room: "room" },

    ModuleType: { Addins: "addins" },

    Month: {
      Apr: "apr",
      Aug: "aug",
      Dec: "dec",
      Feb: "feb",
      Jan: "jan",
      Jul: "jul",
      Jun: "jun",
      Mar: "mar",
      May: "may",
      Nov: "nov",
      Oct: "oct",
      Sep: "sep",
    },

    MoveSpamItemTo: {
      CustomFolder: "customFolder",
      DeletedItemsFolder: "deletedItemsFolder",
      JunkFolder: "junkFolder",
      NoMove: "noMove",
    },

    RecipientType: { DistributionList: "distributionList", ExternalUser: "externalUser", Other: "other", User: "user" },

    RecurrenceType: { Daily: "daily", Monthly: "monthly", Weekday: "weekday", Weekly: "weekly", Yearly: "yearly" },

    ResponseType: {
      Accepted: "accepted",
      Declined: "declined",
      None: "none",
      Organizer: "organizer",
      Tentative: "tentative",
    },

    RestVersion: { Beta: "beta", v1_0: "v1.0", v2_0: "v2.0" },

    SendModeOverride: { PromptUser: "promptUser" },

    UserProfileType: { Enterprise: "enterprise", Office365: "office365", OutlookCom: "outlookCom" },

    WeekNumber: { First: "first", Fourth: "fourth", Last: "last", Second: "second", Third: "third" },
  },
};
